// extracted by mini-css-extract-plugin
module.exports = {"p":"UsernameForm_p__1M8if","span":"UsernameForm_span__393Ne","button":"UsernameForm_button__20LV3","footer":"UsernameForm_footer__3Re88"};